// Index constants
export const FIRST_INDEX = 0;

// Timeout constants (in milliseconds)
export const FOCUS_TIMEOUT_VALUE = 300;
export const TOAST_TIMEOUT = 1500;
export const DEBOUNCE_TIMEOUT = 700;

// Formatting constants
export const DECIMAL_VALUE = 2;
export const MAX_DATEPART_LENGTH = 4;

// Dimension constants
export const MIN_HEIGHT = 460;
export const DEFAULT_MIN_HEIGHT = 460;

// Tab/Index constants for filters
export const TAB_INDEX = 10;
export const RESET_INDEX = 2;
export const ADDITIONAL_FILTERS_INDEX = 5;
export const MAIN_FILTERS_INDEX = 1;
export const APPLY_BUTTON_INDEX = 2;
export const RESET_FILTER_INDEX = 2;
